/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_NotesInputs */

const en_case_detail_notes = /** @type {(inputs: Case_Detail_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const pt_br2_case_detail_notes = /** @type {(inputs: Case_Detail_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anotações`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Case_Detail_NotesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_notes = /** @type {((inputs?: Case_Detail_NotesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_NotesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_notes(inputs)
	return pt_br2_case_detail_notes(inputs)
});